import * as React from "react";
import Form from "react-bootstrap/Form";

function myCustomTemplate(locals: Object) {
  const hasPasswordToggle =
    locals.config && typeof locals.config.onTogglePassword === "function";
  const inputType = locals.config && locals.config.type
    ? locals.config.type
    : "text";

  return (
    <Form.Group
    // controlId="formPlaintextPassword"
    >
      <Form.Label style={{ fontSize: 14 }}>{locals.config.label}</Form.Label>

      <div className={hasPasswordToggle ? "passwordFieldWrap" : ""}>
        <Form.Control
          // size="sm"
          type={inputType}
          placeholder={locals.config.placeholder}
          onChange={(value) => locals.onChange(value.target.value)}
          value={locals.value}
          className={locals.hasError ? "formcntrl dangerClass" : "formcntrl"}
          style={{ backgroundColor: "#d2d2d2", Color: "black" }}
        />
        {hasPasswordToggle && (
          <button
            type="button"
            className="passwordToggleBtn"
            onClick={locals.config.onTogglePassword}
            aria-label={
              locals.config.showPassword ? "Hide password" : "Show password"
            }
          >
            <i
              className={
                locals.config.showPassword ? "fa fa-eye-slash" : "fa fa-eye"
              }
            />
          </button>
        )}
      </div>

      {locals.hasError && (
        <p className="errormessage">{locals.config.errorMessage}</p>
      )}
    </Form.Group>
  );
}
export default myCustomTemplate;
